import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const AdminTabs = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isAdminHome = location.pathname === "/admin";
    const isGemaMaster = location.pathname === "/admin/gema";
    const activePath = isGemaMaster ? "/admin/gema" : "/admin";

    return (
        <div className="rounded-xl border border-gray-200 bg-white p-2 shadow-sm">
            <div className="sm:hidden">
                <label htmlFor="admin-nav-mobile" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Admin Menü
                </label>
                <select
                    id="admin-nav-mobile"
                    value={activePath}
                    onChange={(event) => navigate(event.target.value)}
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-800 focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-200"
                >
                    <option value="/admin">Admin Menü</option>
                    <option value="/admin/gema">GEMA-Master</option>
                </select>
            </div>
            <div className="hidden sm:flex flex-wrap items-center gap-2">
                <Link
                    to="/admin"
                    className={`rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${
                        isAdminHome
                            ? "bg-purple-600 text-white"
                            : "bg-purple-50 text-purple-700 hover:bg-purple-100"
                    }`}
                >
                    Admin Menü
                </Link>
                <Link
                    to="/admin/gema"
                    className={`rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${
                        isGemaMaster
                            ? "bg-red-600 text-white"
                            : "bg-red-50 text-red-700 hover:bg-red-100"
                    }`}
                >
                    GEMA-Master
                </Link>
            </div>
        </div>
    );
};

export default AdminTabs;
